import { adminUserRoutes } from '@/router/admin/adminUserRoutes.js';
import { adminYearRoutes } from '@/router/admin/adminYearRoutes.js';
import { adminTeamRoutes } from '@/router/admin/adminTeamRoutes.js';
import { adminHomeRoutes } from '@/router/admin/adminHomeRoutes';
import { adminBranchRoutes } from '@/router/admin/adminBranchRoutes';
import { adminSettingsRoutes } from '@/router/admin/adminSettingsRoutes';
import { Router } from 'vue-router';
import { userAccountRoutes } from '../user/userAccountRoutes';
import { adminJudgeRoutes } from './adminJudgeRoutes';

export async function addAdminRoutes(router: Router) {
  adminUserRoutes.forEach((route) => router.addRoute(route));
  adminYearRoutes.forEach((route) => router.addRoute(route));
  adminHomeRoutes.forEach((route) => router.addRoute(route));
  adminTeamRoutes.forEach((route) => router.addRoute(route));
  adminBranchRoutes.forEach((route) => router.addRoute(route));
  adminSettingsRoutes.forEach((route) => router.addRoute(route));
  adminJudgeRoutes.forEach((route) => router.addRoute(route));
  userAccountRoutes.forEach((route) => router.addRoute(route));
}
